import {
  Button,
  useBreakpointValue,
} from '@chakra-ui/react';
import React from 'react';

const MainButton = (props: any) => {
  const isSmallScreen = useBreakpointValue({ base: true, sm: false });
  return (
    <Button
      mt={10}
      mb={3}
      w={isSmallScreen ? '100%' : 'min-content'}
      colorScheme="blue"
      {...props}
    />
  );
};

export default MainButton;
